import EZAddToCartAlerts from './EZAddToCartAlerts'

export default EZAddToCartAlerts
